import React, { useState } from 'react';
import useCategoriesContext from '@sls-react/contexts/CategoriesContext';
import useMobile from '@sls-react/hooks/useMobile';
import classNames from 'classnames';
import HorizontalOnlyUnlimitedTile from '@sls-react/components/legos/Tiles/HorizontalOnlyUnlimitedTile';

const CategorySelections = () => {
  const mobile = useMobile();
  const categories = useCategoriesContext();
  const [expanded, setExpanded] = useState(false);

  if (!categories) {
    return null;
  }

  return (
    <>
      <div
        className={classNames('grid gap-2 grid-cols-1 md:grid-cols-3 md:gap-4')}
      >
        {categories.map((category, i) => (
          <a
            key={category.id}
            href={category.url}
            className={classNames([
              !expanded && mobile && i >= 8 && 'hidden',
              !expanded && !mobile && i >= 15 && 'hidden',
            ])}
          >
            <HorizontalOnlyUnlimitedTile
              image={category.icon_url!}
              title={category.name}
            />
          </a>
        ))}
      </div>

      <button
        className="w-full py-2 mt-4 text-sm font-semibold bg-white border rounded border-grey-500"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? 'VIEW LESS' : 'VIEW ALL'}
      </button>
    </>
  );
};

export default CategorySelections;
